(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!window.__atcListenerAttached) {
    window.__atcListenerAttached = true;

    const showError = (errorEl, message) => {
      if (!errorEl) return;

      errorEl.textContent = message;
      errorEl.classList.add('is--visible');
      clearTimeout(errorEl._timer);
      errorEl._timer = setTimeout(() => errorEl.classList.remove('is--visible'), 5000);
    };

    const getErrorElement = (btn) =>
      btn.nextElementSibling?.classList.contains('js--atc-error') ? btn.nextElementSibling : null;

    const formatOptionList = (labels) => {
      return labels.join(', ');
    };

    const getMissingSelectionMessage = (form) => {
      if (!form) return null;

      const optionGroups = Array.from(form.querySelectorAll('[data-option-group]'));
      if (!optionGroups.length) return null;

      const displayOrderedGroups = optionGroups.slice().sort((a, b) => {
        const aOrder = parseInt(a.style.order || window.getComputedStyle(a).order, 10);
        const bOrder = parseInt(b.style.order || window.getComputedStyle(b).order, 10);
        return (Number.isNaN(aOrder) ? 0 : aOrder) - (Number.isNaN(bOrder) ? 0 : bOrder);
      });

      const missingLabels = displayOrderedGroups.reduce((labels, group) => {
        const selectedButton = group.querySelector('[data-option-button].is-selected');
        if (!selectedButton) {
          labels.push(group.dataset.optionName || 'option');
        }
        return labels;
      }, []);

      if (!missingLabels.length) return null;

      return `Plz select "${formatOptionList(missingLabels)}"`;
    };

    const handleAddToCart = async (btn, form = null) => {
      const variantInput = form?.querySelector('input[name="id"]');
      const quantityInput =
        form?.querySelector('input[name="quantity"]') ||
        (btn.dataset.qtyInput ? document.getElementById(btn.dataset.qtyInput) : null);

      const variantId = variantInput?.value || btn.dataset.variantId;
      const comparePrice = parseInt(btn.dataset.comparePrice, 10) || 0;
      const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      const errorEl = getErrorElement(btn);

      if (!variantId) {
        showError(errorEl, getMissingSelectionMessage(form) || 'Could not add to cart.');
        return;
      }

      btn.disabled = true;
      if (errorEl) errorEl.classList.remove('is--visible');

      try {
        const item = { id: parseInt(variantId, 10), quantity };
        if (comparePrice > 0) item.properties = { _compare_price: comparePrice };

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });

        if (!addRes.ok) throw await addRes.json();

        const cart = await fetch('/cart.js').then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { cart } }));
      } catch (err) {
        const cart = await fetch('/cart.js').then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { cart } }));
        showError(errorEl, err?.description ?? 'Could not add to cart.');
      } finally {
        btn.disabled = false;
      }
    };

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.js--atc');
      if (!btn) return;

      const form = btn.form || btn.closest('[data-product-form]');
      e.preventDefault();
      await handleAddToCart(btn, form?.matches('[data-product-form]') ? form : null);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fullpage-border"] && !Shopify.designMode) return;
  try {
    const toggleBtn = document.querySelector('.mobile-nav-toggle');
  const closeBtn = document.querySelector('.mobile-nav__close');
  const nav = document.getElementById('mobile-nav');

  function openNav() {
    nav.classList.add('js--active');
    nav.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    nav.classList.remove('js--active');
    nav.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', openNav);
  closeBtn.addEventListener('click', closeNav);

  // Cart drawer
  var cartDrawer = document.getElementById('cart-drawer');

  function formatMoney(cents) {
    var formatted = window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(cents, cartDrawer.dataset.moneyFormat)
      : '$' + (cents / 100).toFixed(2);
    return formatted.replace(/\.00$/, '');
  }

  function openCartDrawer() {
    cartDrawer.classList.add('js--active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('js--active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('.js--cart-count').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.js--cart-badge').forEach(function (el) {
      el.classList.toggle('is--hidden', count === 0);
    });
  }

  function renderCartBody(cart) {
    var body = cartDrawer.querySelector('.js--cart-body');
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
      return;
    }
    var items = cart.items
      .map(function (item) {
        console.log('item',item);
        
        var img = item.featured_image
          ? '<a href="' + item.url + '" class="cart-drawer__item-img-link" tabindex="-1" aria-hidden="true"><img src="' + item.featured_image.url + '" alt="" width="80" height="80" loading="lazy"></a>'
          : '';
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
            : '';
        return (
          '<li class="cart-drawer__item" data-key="' +
          item.key +
          '">' +
          img +
          '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' +
          item.product_title +
          '</a>' +
          variant +
          '<a href="' + item.url + '" class="cart-drawer__item-price">' +
          (item.properties && item.properties._compare_price && item.properties._compare_price > item.original_price
            ? '<s class="cart-drawer__item-price-compare">' + formatMoney(item.properties._compare_price) + '</s>'
            : '') +
          formatMoney(item.final_price) +
          '</a>' +
          '<div class="cart-drawer__item-footer">' +
          '<div class="cart-drawer__qty">' +
          '<button class="cart-drawer__qty-btn js--qty-minus" data-key="' +
          item.key +
          '" aria-label="Decrease quantity">−</button>' +
          '<input class="cart-drawer__qty-input js--qty-input" type="number" value="' +
          item.quantity +
          '" min="0" data-key="' +
          item.key +
          '">' +
          '<button class="cart-drawer__qty-btn js--qty-plus" data-key="' +
          item.key +
          '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="cart-drawer__item-remove js--cart-remove" data-key="' +
          item.key +
          '" aria-label="Remove"><img src="' + cartDrawer.dataset.trashIcon + '" alt="" aria-hidden="true" width="168" height="194"></button>' +
          '</div>' +
          '<div class="cart-drawer__item-error js--item-error" aria-live="polite"></div>' +
          '</div>' +
          '</li>'
        );
      })
      .join('');
    body.innerHTML =
      '<ul class="cart-drawer__items">' +
      items +
      '</ul>' +
      '<div class="cart-drawer__total"><span>Total</span><span>' +
      formatMoney(cart.total_price) +
      '</span></div>';
  }

  function showCartError(message, key) {
    var el = key
      ? cartDrawer.querySelector('.cart-drawer__item[data-key="' + key + '"] .js--item-error')
      : null;
    if (!el) return;
    el.textContent = message;
    el.classList.add('is--visible');
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      el.classList.remove('is--visible');
    }, 4000);
  }

  var qtyTimers = {};
  var qtyRevertValues = {};

  function setQtyLoading(key, loading) {
    var input = cartDrawer.querySelector('.js--qty-input[data-key="' + key + '"]');
    if (!input) return;
    var qtyEl = input.closest('.cart-drawer__qty');
    if (!qtyEl) return;
    qtyEl.classList.toggle('is--loading', loading);
    input.disabled = loading;
    qtyEl.querySelectorAll('.cart-drawer__qty-btn').forEach(function (btn) {
      btn.disabled = loading;
    });
  }

  function scheduleCartQtyUpdate(key, quantity) {
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      var revertQty = qtyRevertValues[key];
      delete qtyRevertValues[key];
      setQtyLoading(key, true);
      updateCartQty(key, quantity, revertQty);
    }, 1000);
  }

  function updateCartQty(key, quantity, revertQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            console.error('Cart change failed:', err);
            setQtyLoading(key, false);
            if (revertQty !== undefined) {
              var input = cartDrawer.querySelector('.js--qty-input[data-key="' + key + '"]');
              if (input) input.value = revertQty;
            }
            showCartError(err.description || err.message || 'Something went wrong.', key);
          });
        }
        return res.json().then(function (cart) {
          updateCartCount(cart.item_count);
          renderCartBody(cart);
        });
      })
      .catch(function (err) {
        console.error('Cart change error:', err);
        setQtyLoading(key, false);
        if (revertQty !== undefined) {
          var input = cartDrawer.querySelector('.js--qty-input[data-key="' + key + '"]');
          if (input) input.value = revertQty;
        }
      });
  }

  document.querySelector('.js--open-cart').addEventListener('click', function (e) {
    e.preventDefault();
    openCartDrawer();
  });

  cartDrawer.addEventListener('click', function (e) {
    if (e.target.closest('.js--close-cart')) {
      closeCartDrawer();
    }
    var removeBtn = e.target.closest('.js--cart-remove');
    if (removeBtn) {
      var itemEl = removeBtn.closest('.cart-drawer__item');
      if (itemEl) itemEl.classList.add('is--removing');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.key, quantity: 0 }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          renderCartBody(cart);
        });
    }
    var minusBtn = e.target.closest('.js--qty-minus');
    if (minusBtn) {
      var minusInput = cartDrawer.querySelector('.js--qty-input[data-key="' + minusBtn.dataset.key + '"]');
      var currentQty = parseInt(minusInput.value, 10);
      if (!(minusBtn.dataset.key in qtyRevertValues)) {
        qtyRevertValues[minusBtn.dataset.key] = currentQty;
      }
      var newQty = Math.max(0, currentQty - 1);
      minusInput.value = newQty;
      scheduleCartQtyUpdate(minusBtn.dataset.key, newQty);
    }
    var plusBtn = e.target.closest('.js--qty-plus');
    if (plusBtn) {
      var plusInput = cartDrawer.querySelector('.js--qty-input[data-key="' + plusBtn.dataset.key + '"]');
      var currentQty = parseInt(plusInput.value, 10);
      if (!(plusBtn.dataset.key in qtyRevertValues)) {
        qtyRevertValues[plusBtn.dataset.key] = currentQty;
      }
      var newQty = currentQty + 1;
      plusInput.value = newQty;
      scheduleCartQtyUpdate(plusBtn.dataset.key, newQty);
    }
  });

  cartDrawer.addEventListener('change', function (e) {
    var input = e.target.closest('.js--qty-input');
    if (input) {
      if (!(input.dataset.key in qtyRevertValues)) {
        qtyRevertValues[input.dataset.key] = parseInt(input.defaultValue, 10) || 0;
      }
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newQty;
      scheduleCartQtyUpdate(input.dataset.key, newQty);
    }
  });

  document.addEventListener('cart:error', function (e) {
    openCartDrawer();
    var firstItem = cartDrawer.querySelector('.cart-drawer__item');
    if (firstItem) {
      showCartError(e.detail.message, firstItem.dataset.key);
    }
  });

  document.addEventListener('cart:item-added', function (e) {
    var cart = e.detail.cart;
    updateCartCount(cart.item_count);
    renderCartBody(cart);
    openCartDrawer();
  });
  } catch(e) { console.error(e); }
})();

})();
